import React, { useEffect } from 'react';
import styles from './Timer.module.scss';
import clock from '../../assets/clock-small.svg';
import appStyles from '../../App.module.scss';

export interface ITimerProps {
    onTimerUpdate: (time: number) => void;
    isPaused: boolean;
}

export function Timer(props: ITimerProps) {
    const { onTimerUpdate, isPaused } = props;

    const [time, setTime] = React.useState(0);
    const [hideTimer, setHideTimer] = React.useState(false);

    useEffect(() => {
        // Sets time from 0 to 1 every 10 miliseconds using setInterval
        let intervalId: NodeJS.Timer | undefined = undefined;

        if (isPaused === false) {
            intervalId = setInterval(() => setTime(time + 1), 10);
            onTimerUpdate(time + 1);
        } else {
            clearInterval(intervalId);
        }

        return () => clearInterval(intervalId);
    }, [isPaused, time, onTimerUpdate]);

    // Minutes calculation
    const minutes = Math.floor((time % 360000) / 6000);

    // Seconds calculation
    const seconds = Math.floor((time % 6000) / 100);

    const timeAsString = minutes.toString().padStart(2, "0") + ':' + seconds.toString().padStart(2, "0");

    return (
        <div className={styles.timerRoot}>
            {
            !hideTimer && 
            <div className={styles.timeAsString}>
                {timeAsString}
            </div>
        }
            <button 
                onClick={() => {
                    setHideTimer(!hideTimer);
                }}
                aria-label='Click to show/hide timer'
                className={appStyles.basicButton}
            >
                <img className={styles.buttonImg} src={clock} alt='clock' />
            </button>
        </div>
    );
}